module.exports = __webpack_public_path__ + "static/media/Arrow.28cfe926.svg";